export const RESTO365_FAQ = 'RESTO365_FAQ'

export const RESTO365_FAQ_CATEGORY = `${RESTO365_FAQ}/listResto365FAQCategory`

export const RESTO365_FAQ_CREATE = `${RESTO365_FAQ}/createResto365FAQ`

export const RESTO365_FAQ_LIST = `${RESTO365_FAQ}/listResto365FAQ`

export const RESTO365_FAQ_BY_ID = `${RESTO365_FAQ}/Resto365FAQById`

export const RESTO365_FAQ_UPDATE = `${RESTO365_FAQ}/updateResto365FAQ`

export const RESTO365_FAQ_DELETE = `${RESTO365_FAQ}/deleteResto365FAQ`
